import React, { useState, useEffect } from 'react';
import { Download, ChevronLeft, ChevronRight } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';

export const PDFCatalogRenderer = () => {
  const [numPages, setNumPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pdfImages, setPdfImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    // For now, show a message that PDF rendering will work in production
    // In Emergent preview, we'll show the download option
    setLoading(false);
    setError(true);
  }, []);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = siteConfig.catalogPdfPath;
    link.download = 'Dovira-Catalog.pdf';
    link.click();
  };

  return (
    <div className="pdf-catalog-renderer">
      {/* Controls */}
      <div className="pdf-catalog-controls">
        <button 
          onClick={handleDownload}
          className="pdf-download-button"
        >
          <Download size={18} />
          Завантажити PDF
        </button>
      </div>

      {/* PDF Display using iframe fallback */}
      <div className="pdf-catalog-content">
        <div className="pdf-iframe-container">
          <iframe
            src={`${siteConfig.catalogPdfPath}#toolbar=1&navpanes=1&scrollbar=1&view=FitH&zoom=page-fit`}
            title="Каталог продукції"
            className="pdf-catalog-iframe"
          />
        </div>
        
        <div className="pdf-fallback-info">
          <p>
            📄 Каталог доступний для перегляду вище. 
            Якщо PDF не відображається, натисніть кнопку "Завантажити PDF" щоб переглянути файл.
          </p>
          <p className="pdf-note">
            💡 У production версії сайту PDF буде відображатися коректно на всіх пристроях.
          </p>
        </div>
      </div>
    </div>
  );
};
